import React, { type FC } from 'react'
import DashboardLayout from './DashboardLayout'
import { Navigate, Route, Routes } from 'react-router-dom'
import axiosRetry from 'axios-retry'
import axios from 'axios'
import Login from '../../login/Login'
import { useAuth } from 'react-oidc-context'
import { Loader } from '@scuf/common'
import { oidcConfig } from '../../../forgeiam/authConfig'
import { escapeHTML } from '../../../utils/escapeHTML'
import CustomKpiList from '../../custom-performance-indicators/components/KpiListComponent'
import CreateCustomKpi from '../../custom-performance-indicators/components/create-custom-kpi/CreateCustomKpi'
import DeviceListComponent from '../../device-management/components/DeviceTable/DeviceListComponent'
import AddDevice from '../../device-management/components/AddDevice/AddDeviceComponent'
import GatewayListComponent from '../../gateway-management/components/GatewayTable/GatewayListComponent'
import EditDeviceComponent from '../../device-management/components/EditDevice/EditDeviceComponent'
import DeviceDashboardMain from '../../device-dashboard/components/deviceDashboardMain'
import AssetListComponent from '../../asset-managament/components/AssetTable/AssetListComponent'
import AddGatewayComponent from '../../gateway-management/components/AddGateway/AddGatewayComponent'
import AddAssetComponent from '../../asset-managament/components/AddAsset/AddAssetComponent'
import EditGatewayComponent from '../../gateway-management/components/EditGateway/EditGatewayComponent'
import EditAssetComponent from '../../asset-managament/components/EditAsset/EditAssetComponent'
import SiteListComponent from '../../site-management/components/SiteTable/SiteListComponent'
import AddSiteComponent from '../../site-management/components/AddSite/AddSite'
import EditSiteComponent from '../../site-management/components/EditSite/EditSite'
import EditCustomKpi from '../../custom-performance-indicators/components/edit-custom-kpi/EditCustomKpi'
import CustomDeviceListComponent from '../../custom-device/components/DeviceTable/DeviceListComponent'
import AssetDashboardMain from '../../asset-dashboard/components/main-dashboard'
import DefaultComponent from './defaultComponent'
import EmailNotificationListComponent from '../../services/components/EmailNotificationListComponent'
import WebSocketTestPanel from '../../../components/WebSocketTestPanel'
import WebSocketDiagnostics from '../../../components/WebSocketDiagnostics'
import AssetRegistration from '../../asset-management/components/AssetRegistration'

axiosRetry(axios, { retries: 3 })

const OidcSecure: FC<any> = ({ children }) => {
  const auth = useAuth()
  const oidcStorage = localStorage.getItem(`oidc.user:${oidcConfig.authority ?? ''}:${oidcConfig.client_id ?? ''}`)
  if (auth.isLoading) {
    return <Loader><div className='placeholder' /></Loader>
  } else if (oidcStorage != null || auth.isAuthenticated) {
    return <>{children}</>
  } else {
    localStorage.setItem('redirectUri', escapeHTML(window.location.pathname))
    return (<Navigate to='/login' />)
  }
}

const Main = (props: any): any => {
  return (
    <>
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/logout' element={<Navigate to='/login' />} />
        <Route path="/" element={<DashboardLayout />}>
          <Route index element={<OidcSecure><Navigate to='/asset-registration' replace /></OidcSecure>} />
          <Route path="/thermal-dashboard" element={<OidcSecure><Navigate to='/asset-registration' replace /></OidcSecure>} />
          <Route path="/custom-kpi-list" element={<OidcSecure><CustomKpiList /></OidcSecure>} />
          <Route path="/create-custom-kpi" element={<OidcSecure><CreateCustomKpi /></OidcSecure>} />
          <Route path="/device-list/:parentAssetId" element={<OidcSecure><DeviceListComponent /></OidcSecure>} />
          <Route path="/edit-device/:deviceIdParam" element={<OidcSecure><EditDeviceComponent /></OidcSecure>} />
          <Route path="/gateway-list/:parentAssetId" element={<OidcSecure><GatewayListComponent /></OidcSecure>} />
          <Route path="/thermal-asset-list/:parentAssetId" element={<OidcSecure><AssetListComponent /></OidcSecure>} />
          <Route path="/create-device/:parentAssetId" element={<OidcSecure><AddDevice /></OidcSecure>} />
          <Route path="/device-dashboard" element={<OidcSecure><DeviceDashboardMain /></OidcSecure>} />
          <Route path="/create-gateway/:parentAssetId" element={<OidcSecure><AddGatewayComponent /></OidcSecure>} />
          <Route path="/create-asset/:parentAssetId" element={<OidcSecure><AddAssetComponent /></OidcSecure>} />
          <Route path="/edit-gateway/:gatewayIdParam" element={<OidcSecure><EditGatewayComponent /></OidcSecure>} />
          <Route path="/edit-asset/:assetId" element={<OidcSecure><EditAssetComponent /></OidcSecure>} />
          <Route path="/site-list" element={<OidcSecure><SiteListComponent /></OidcSecure>} />
          <Route path="/create-site" element={<OidcSecure><AddSiteComponent /></OidcSecure>} />
          <Route path="/edit-site/:siteIdParam" element={<OidcSecure><EditSiteComponent /></OidcSecure>} />
          <Route path="/edit-custom-kpi" element={<OidcSecure><EditCustomKpi /></OidcSecure>} />
          <Route path="/custom-device-template-list" element={<OidcSecure><CustomDeviceListComponent /></OidcSecure>} />
          <Route path="/asset-dashboard" element={<OidcSecure><AssetDashboardMain /></OidcSecure>} />
          <Route path="/asset-registration" element={<OidcSecure><AssetRegistration /></OidcSecure>} />
          <Route path="/get-started/" element={<OidcSecure><DefaultComponent /></OidcSecure>} />
          <Route path="/email-service-list" element={<OidcSecure><EmailNotificationListComponent /></OidcSecure>} />
          <Route path="/websocket-test" element={<OidcSecure><WebSocketTestPanel /></OidcSecure>} />
          <Route path="/websocket-diagnostics" element={<OidcSecure><WebSocketDiagnostics /></OidcSecure>} />
        </Route>
      </Routes>
    </>
  )
}

export default Main
